import { render, staticRenderFns } from "./serviceInfo.vue?vue&type=template&id=ce1d0756"
import script from "./serviceInfo.vue?vue&type=script&lang=js"
export * from "./serviceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports